import type { ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';
import { AnimatedSection } from './AnimatedSection';

interface PageHeroProps {
  badgeIcon: Icon;
  badgeLabel: string;
  /** Headline; pass a gold `<span className="text-gradient-gold">` for the second clause. */
  title: ReactNode;
  lead: ReactNode;
}

/** Centered hero with a gold pill badge, used by the trust pages (Security, Data Freedom). */
export function PageHero({
  badgeIcon: BadgeIcon,
  badgeLabel,
  title,
  lead,
}: Readonly<PageHeroProps>) {
  return (
    <section className="relative pt-28 pb-16 px-4 sm:px-6 text-center overflow-hidden">
      <div className="relative z-10 max-w-4xl mx-auto">
        <AnimatedSection>
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-slate-800/80 border border-slate-700 text-xs font-mono font-medium uppercase tracking-wider text-slate-300 mb-6">
            <BadgeIcon className="w-4 h-4" weight="fill" />
            <span>{badgeLabel}</span>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.1}>
          <h1 className="hero-h1 font-bold text-white mb-5">{title}</h1>
        </AnimatedSection>

        <AnimatedSection delay={0.2}>
          <p className="hero-lead text-white/65 max-w-2xl mx-auto mb-8">{lead}</p>
        </AnimatedSection>
      </div>
    </section>
  );
}
